const ACCESSHUB_BASE = 'https://davids-beacon-accesshub.web.app'
const SAFETY_BASE = 'https://davidsbeacon.com'

export const PLATFORM_URLS = {
  safety: {
    base: SAFETY_BASE,
  },
  accesshub: {
    base: ACCESSHUB_BASE,
    jobDetail: (_id: string) => `${ACCESSHUB_BASE}/jobs`,
    submitJob: `${ACCESSHUB_BASE}/submit/job`,
    submitVenue: `${ACCESSHUB_BASE}/submit/venue`,
  },
}
